<script lang="ts">
	import { page } from '$app/state'
	import Spinner from '../loading/Spinner.svelte'

	let isHighlights = $derived(page?.url?.pathname.endsWith('/highlights') ?? false)
</script>

<div
	class="flex items-center justify-center h-[100dvh] lg:min-h-screen text-center text-black dark:text-white w-full flex-shrink-0 max-h-[70vh] lg:max-h-none overflow-y-auto rounded-t-xl lg:rounded-none"
>
	<Spinner
		size="md"
		class={isHighlights
			? 'border-brand-gray-6 dark:border-brand-gray-6 lg:border-brand-gray-2 lg:dark:border-brand-gray-2'
			: ''}
	/>
</div>
